import React from 'react';
import { NavLink } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import '../styles/MenuMobile.scss';
import { GoPlus } from "react-icons/go";
import { PiUserPlus } from "react-icons/pi";
import { CiSearch } from "react-icons/ci";
import { FiFileText, FiUser, FiMessageSquare, FiBarChart2, FiLogOut, FiHome, FiMapPin } from "react-icons/fi";
import { MdOutlineAnnouncement } from "react-icons/md";
import tofProfil from '../assets/profile.png';
import { useTranslation } from 'react-i18next';

function MenuMobile({user, show, onHide, isCon, onSignOut, onShowLogin, onShowTracking, nbnotif, setNbnotif }) {
    const { t } = useTranslation();

    const handleNavClick = () => {
        if (show) onHide();
    };

    const handleLoginClick = () => {
        onHide();
        if (onShowLogin) onShowLogin();
    };

    const handleSignOutClick = () => {
        onHide();
        if (onSignOut) onSignOut();
    };

  return (
    <Modal show={show} onHide={onHide} size="xs" className='MenuMobile'>
      <Modal.Header closeButton>
        <Modal.Title>
            <span>{t('menu.title')}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
          {isCon ?
            <NavLink onClick={handleNavClick} className='MenuMobile_link' to='/profil'>
                <img
                    className="MenuMobile_link_img"
                    src={(user && user.photoURL && user.photoURL!==null) ? user.photoURL : tofProfil}
                    onError={(e) => {
                        e.target.src = tofProfil;
                    }}
                    width="15"
                    height="15"
                    alt="profile"
                />
                <span className='MenuMobile_link_span'>{t('menu.myAccount')}</span>
            </NavLink> :
            <div onClick={handleLoginClick} className='MenuMobile_link'>
                <PiUserPlus className='MenuMobile_link_icon'/>
                <span className='MenuMobile_link_span'>{t('menu.createAccount')}</span>
            </div>
          }
          <NavLink onClick={handleNavClick} className='MenuMobile_link' to='/'>
            <FiHome className='MenuMobile_link_icon'/>
            <span className='MenuMobile_link_span'>{t('menu.home')}</span>
          </NavLink>
          {isCon ?
            <NavLink onClick={handleNavClick} className='MenuMobile_link' to='/ajoutAnnonce'>
              <GoPlus className='MenuMobile_link_icon'/>
              <span className='MenuMobile_link_span'>{t('menu.postAd')}</span>
            </NavLink> :
            <div onClick={handleLoginClick} className='MenuMobile_link'>
              <GoPlus className='MenuMobile_link_icon'/>
              <span className='MenuMobile_link_span'>{t('menu.postAd')}</span>
            </div>
          }
          <NavLink onClick={handleNavClick} className='MenuMobile_link' to='/service'>
            <CiSearch className='MenuMobile_link_icon'/>
            <span className='MenuMobile_link_span'>{t('menu.searchAd')}</span>
          </NavLink>
          <div onClick={() => { onHide(); if (isCon && onShowTracking) onShowTracking(); else if (!isCon) handleLoginClick(); }} className='MenuMobile_link'>
            <FiMapPin className='MenuMobile_link_icon'/>
            <span className='MenuMobile_link_span'>{t('nav.map')}</span>
          </div>
          {isCon &&
            <>
              <NavLink onClick={handleNavClick} className='MenuMobile_link' to='/showAnnonce'>
                <MdOutlineAnnouncement className='MenuMobile_link_icon'/>
                <span className='MenuMobile_link_span'>{t('nav.myAds')}</span>
              </NavLink>
              <NavLink onClick={() => { handleNavClick(); if (setNbnotif) setNbnotif(0); }} className='MenuMobile_link' to='/chat' state={{}}>
                <FiMessageSquare className='MenuMobile_link_icon'/>
                <span className='MenuMobile_link_span'>{t('nav.notifications')} {nbnotif > 0 && <span className="badge badge-dark">{nbnotif}</span>}</span>
              </NavLink>
              <NavLink onClick={handleNavClick} className='MenuMobile_link' to='/showStatistique'>
                <FiBarChart2 className='MenuMobile_link_icon'/>
                <span className='MenuMobile_link_span'>{t('show.statistics')}</span>
              </NavLink>
            </>
          }
          {isCon &&
            <div onClick={handleSignOutClick} className='MenuMobile_link MenuMobile_link_logout'>
              <FiLogOut className='MenuMobile_link_icon'/>
              <span className='MenuMobile_link_span'>{t('nav.logout')}</span>
            </div>
          }
      </Modal.Body>
    </Modal>
  )
}

export default MenuMobile